import 'select2/dist/js/select2.js';

export default class Tools {
    static initSelect2() {
        $('.js-select').each(function () {
            const params = $(this).data('params');
            $(this).select2(params);
            const $this = $(this);

            $('.select2-selection').keydown((e) => {
                if(e.key === 'Enter'){
                    $this.select2('close')
                }
            })
        });


    }

    static initYouTubeApi(){
        const tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}